export const PLAN_KEYS = ['FREE', 'EARLY_ACCESS', 'BASIC', 'PRO'] as const;
export type PlanKey = (typeof PLAN_KEYS)[number];

export interface PlanLimits {
  label: string;
  userLimit: number | null; // null = brak twardego limitu
  bytesLimit: number | null;
}

const GiB = 1024 * 1024 * 1024;

// WARTOŚCI DO KALIBRACJI — stała, łatwa do zmiany.
// UWAGA: EARLY_ACCESS celowo ma WIĘCEJ userów niż BASIC — to promocyjny tier dla
// pierwszych testerów (hojny), nie zwykły szczebel cennika. Nie zakładać ścisłego
// porządku limitów po kolejności enuma.
export const PLAN_LIMITS: Record<PlanKey, PlanLimits> = {
  FREE: { label: 'Free', userLimit: 2, bytesLimit: 1 * GiB },
  EARLY_ACCESS: { label: 'Early Access', userLimit: 10, bytesLimit: 10 * GiB },
  BASIC: { label: 'Basic', userLimit: 5, bytesLimit: 25 * GiB },
  PRO: { label: 'Pro', userLimit: null, bytesLimit: 100 * GiB },
};

/**
 * Efektywny limit userów: override (per org, ustawiany przez SUPER_ADMINa) wygrywa
 * z domyślnym z planu. `null` = brak twardego limitu (np. PRO).
 * UWAGA: override `0` jest poprawną wartością i BLOKUJE dodawanie userów (hard freeze org).
 */
export function getEffectiveUserLimit(
  plan: PlanKey,
  override: number | null | undefined,
): number | null {
  if (override !== null && override !== undefined) return override;
  return PLAN_LIMITS[plan].userLimit;
}
